var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarCodeNoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215 4221 c-22 -10 -54 -34 -72 -52 -68 -72 -63 48 -63 -1609 0 -1657 -5 -1537 63 -1609 18 -18 50 -42 72 -52 39 -18 121 -19 2345 -19 2224 0 2306 1 2345 19 22 10 54 34 72 52 68 72 63 -48 63 1611 0 1443 -1 1505 -19 1543 -23 49 -74 99 -123 119 -33 14 -282 16 -2340 16 -2222 0 -2304 -1 -2343 -19z m4605 -152 c63 -23 60 65 60 -1509 0 -1574 3 -1486 -60 -1509 -47 -16 -4473 -16 -4520 0 -63 23 -60 -64 -60 1507 0 1040 3 1438 11 1462 8 21 23 37 43 46 26 11 407 13 2262 14 1640 0 2240 -3 2264 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 2640 l0 -1280 160 0 160 0 0 1280 0 1280 -160 0 -160 0 0 -1280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 3040 l0 -880 80 0 80 0 0 880 0 880 -80 0 -80 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 3040 l0 -880 160 0 160 0 0 880 0 880 -160 0 -160 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 3040 l0 -880 240 0 240 0 0 880 0 880 -240 0 -240 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 3040 l0 -880 80 0 80 0 0 880 0 880 -80 0 -80 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 3040 l0 -880 160 0 160 0 0 880 0 880 -160 0 -160 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3200 3040 l0 -880 80 0 80 0 0 880 0 880 -80 0 -80 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3520 3040 l0 -880 80 0 80 0 0 880 0 880 -80 0 -80 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3840 3040 l0 -880 160 0 160 0 0 880 0 880 -160 0 -160 0 0 -880z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4320 2640 l0 -1280 160 0 160 0 0 1280 0 1280 -160 0 -160 0 0 -1280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1920 l0 -80 80 0 80 0 0 -240 0 -240 80 0 80 0 0 300 c0 287 -1 301 -20 320 -18 18 -33 20 -160 20 l-140 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1981 c-49 -23 -99 -74 -119 -123 -25 -58 -22 -309 3 -363 40 -86 120 -135 221 -135 101 0 181 49 221 135 27 59 27 311 0 370 -23 49 -74 99 -123 119 -52 22 -153 20 -203 -3z m145 -161 c26 -14 40 -63 40 -142 0 -116 -34 -162 -106 -144 -35 9 -54 60 -54 145 0 76 12 119 37 139 20 14 57 16 83 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1920 l0 -80 91 0 c83 0 90 -2 84 -17 -62 -151 -95 -290 -95 -399 l0 -64 85 0 85 0 0 55 c0 112 44 265 120 415 35 70 39 121 10 150 -19 19 -33 20 -200 20 l-180 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 1920 l0 -80 80 0 80 0 0 -240 0 -240 80 0 80 0 0 300 c0 287 -1 301 -20 320 -18 18 -33 20 -160 20 l-140 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1920 l0 -80 80 0 80 0 0 -240 0 -240 80 0 80 0 0 300 c0 287 -1 301 -20 320 -18 18 -33 20 -160 20 l-140 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3335 1981 c-49 -23 -99 -74 -119 -123 -25 -58 -22 -309 3 -363 40 -86 120 -135 221 -135 101 0 181 49 221 135 27 59 27 311 0 370 -23 49 -74 99 -123 119 -52 22 -153 20 -203 -3z m145 -161 c26 -14 40 -63 40 -142 0 -116 -34 -162 -106 -144 -35 9 -54 60 -54 145 0 76 12 119 37 139 20 14 57 16 83 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3760 1920 l0 -80 91 0 c83 0 90 -2 84 -17 -62 -151 -95 -290 -95 -399 l0 -64 85 0 85 0 0 55 c0 112 44 265 120 415 35 70 39 121 10 150 -19 19 -33 20 -200 20 l-180 0 0 -80z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCodeNoColor);
export default __webpack_public_path__ + "static/media/barCodeNoColor.f86894f4.svg";
export { ForwardRef as ReactComponent };